import type { StrapiBlock } from '../types';
import { RichTextBlock } from './rich-text-block';
import { MediaBlock } from './media-block';
import { QuoteBlock } from './quote-block';
import { SliderBlock } from './slider-block';

interface ContentBlockProps {
  block: StrapiBlock;
  index: number;
}

export const ContentBlock = ({ block, index }: ContentBlockProps) => {
  switch (block.__component) {
    case 'shared.rich-text':
      return <RichTextBlock key={index} block={block} />;
    case 'shared.media':
      return <MediaBlock key={index} block={block} />;
    case 'shared.quote':
      return <QuoteBlock key={index} block={block} />;
    case 'shared.slider':
      return <SliderBlock key={index} block={block} />;
    default: {
      // Type assertion for the default case
      const unknownBlock = block as { __component: string };
      console.warn(`Unknown block component: ${unknownBlock.__component}`);
      return null;
    }
  }
};
